import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import AddressView from './AddressView.vue';

export const initAddress = () => {
  if (!document.getElementById('address-list-app')) {
    return;
  }

  const app = createApp(AddressView);

  const routes = [
    {
      path: '/spaces',
      name: 'addresses',
      component: AddressView,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.mount('#address-list-app');
};
